<template>
  <div>
    <AddQuestions />
  </div>
</template>
<script>
import AddQuestions from '../../../components/dadban/courses/AddQuestions.vue'
export default {
  name: 'dadban-question-courses',
  components: { AddQuestions },
}
</script>
